// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1lAxD","boxTitle":"Qualiphy_boxTitle__xX1CD","box":"Qualiphy_box__34xq7","toggleWrap":"Qualiphy_toggleWrap__1OjEz"};